import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const CornerRadius = forwardRef(function CornerRadius(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.25 5A.75.75 0 0 1 5 4.25h6A8.75 8.75 0 0 1 19.75 13v6a.75.75 0 0 1-1.5 0v-6A7.25 7.25 0 0 0 11 5.75H5A.75.75 0 0 1 4.25 5Z"
        fill="currentColor"
      />
    </Icon>
  );
});
